import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useRef, useState } from "react";
import { useSellCarData } from "@/common/Contexts/SellCarDataContext";
import { useScreenNavigation } from "@/common/Contexts/ScreenNavigationContext";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import FlowButton from "@/pages/sell-my-car/components/FlowButton";
import FLowLoadingSpinner from "@/pages/sell-my-car/components/FLowLoadingSpinner";
import { trackEvents } from "@/common/events/events";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
var PaymentSuccessScreen = function PaymentSuccessScreen() {
  var _useSellCarData = useSellCarData(),
    state = _useSellCarData.state,
    actions = _useSellCarData.actions;
  var _useScreenNavigation = useScreenNavigation(),
    navActions = _useScreenNavigation.actions;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useState = useState(true),
    isProcessing = _useState[0],
    setIsProcessing = _useState[1];
  var _useState2 = useState(null),
    error = _useState2[0],
    setError = _useState2[1];
  var hasTrackedEvent = useRef(false);
  useEffect(function () {
    handleFetchNextStep();
  }, []);
  var handleFetchNextStep = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _stepData$current_ste, stepData, _state$draftOrder, _state$draftOrder2, _stepData$current_ste2, _stepData$current_ste3, _stepData$current_ste4, _stepData$current_ste5, _stepData$current_ste6, _stepData$current_ste7, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            setIsProcessing(true);
            setError(null);
            _context.p = 1;
            _context.n = 2;
            return actions.fetchStepData();
          case 2:
            stepData = _context.v;
            if (stepData !== null && stepData !== void 0 && (_stepData$current_ste = stepData.current_step) !== null && _stepData$current_ste !== void 0 && _stepData$current_ste.step_key) {
              // Track payment success event
              if (!hasTrackedEvent.current && state !== null && state !== void 0 && (_state$draftOrder = state.draftOrder) !== null && _state$draftOrder !== void 0 && _state$draftOrder.requestId) {
                hasTrackedEvent.current = true;
                trackEvents("sell_car_appointment_book", {
                  order_id: state === null || state === void 0 ? void 0 : (_state$draftOrder2 = state.draftOrder) === null || _state$draftOrder2 === void 0 ? void 0 : _state$draftOrder2.requestId,
                  car_city: (stepData === null || stepData === void 0 ? void 0 : (_stepData$current_ste2 = stepData.current_step) === null || _stepData$current_ste2 === void 0 ? void 0 : (_stepData$current_ste3 = _stepData$current_ste2.data) === null || _stepData$current_ste3 === void 0 ? void 0 : _stepData$current_ste3.city_name) || "",
                  inspection_city: (stepData === null || stepData === void 0 ? void 0 : (_stepData$current_ste4 = stepData.current_step) === null || _stepData$current_ste4 === void 0 ? void 0 : (_stepData$current_ste5 = _stepData$current_ste4.data) === null || _stepData$current_ste5 === void 0 ? void 0 : _stepData$current_ste5.city_name) || "",
                  inspection_location: (stepData === null || stepData === void 0 ? void 0 : (_stepData$current_ste6 = stepData.current_step) === null || _stepData$current_ste6 === void 0 ? void 0 : (_stepData$current_ste7 = _stepData$current_ste6.data) === null || _stepData$current_ste7 === void 0 ? void 0 : _stepData$current_ste7.location) || "",
                  payment_status: "success",
                  platform: getPlatformInfo()
                });
              }

              // Navigate to whatever the backend returns
              navActions.navigateToScreen(stepData.current_step.step_key);
            } else {
              setError(tShort("sell_trade_v2/payment_verification_failed", {
                ns: "web_sell_trade"
              }));
            }
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            console.error("Error fetching next step:", _t);
            setError(tShort("sell_trade_v2/payment_verification_failed", {
              ns: "web_sell_trade"
            }));
          case 4:
            _context.p = 4;
            setIsProcessing(false);
            return _context.f(4);
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3, 4, 5]]);
    }));
    return function handleFetchNextStep() {
      return _ref.apply(this, arguments);
    };
  }();

  // Loading State
  if (isProcessing) {
    return /*#__PURE__*/React.createElement("div", {
      id: "sell-car-payment-success-screen",
      className: "p-4 flex flex-col items-center justify-center min-h-[400px] gap-6"
    }, /*#__PURE__*/React.createElement("img", {
      id: "sell-car-payment-success-icon",
      src: CDN_LINK + "/assets/images/success.svg",
      alt: "Success",
      width: 96,
      height: 82
    }), /*#__PURE__*/React.createElement("h2", {
      id: "sell-car-payment-success-heading",
      className: "text-primary-new text-2xl font-bold text-center"
    }, tShort("sell_trade_v2/payment_success_heading", {
      ns: "web_sell_trade"
    })), /*#__PURE__*/React.createElement("p", {
      id: "sell-car-payment-success-message",
      className: "text-gray-text text-base text-center max-w-[400px]"
    }, tShort("sell_trade_v2/payment_success_message", {
      ns: "web_sell_trade"
    })), /*#__PURE__*/React.createElement(FLowLoadingSpinner, null));
  }

  // Error State
  if (error) {
    return /*#__PURE__*/React.createElement("div", {
      id: "sell-car-payment-success-error-screen",
      className: "p-4 flex flex-col gap-6 md:p-6"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-center justify-center gap-6 max-w-[400px] mx-auto"
    }, /*#__PURE__*/React.createElement("img", {
      id: "sell-car-payment-success-error-icon",
      src: CDN_LINK + "/assets/images/eerre.png",
      alt: "Error",
      className: "w-24 h-24"
    }), /*#__PURE__*/React.createElement("h2", {
      id: "sell-car-payment-success-error-heading",
      className: "text-black-primary text-xl font-bold text-center"
    }, error), /*#__PURE__*/React.createElement(FlowButton, {
      id: "sell-car-payment-success-retry-btn",
      onClick: handleFetchNextStep
    }, tShort("sell_trade_v2/try_again", {
      ns: "web_sell_trade"
    }))));
  }
  return null;
};
export default PaymentSuccessScreen;